import { useState } from 'react';
import { faqData } from '@/mocks/anime';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full py-10 md:py-14 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-50 font-heading mb-2">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-400">
            关于51动漫官网，你想知道的都在这里
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-100 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-200 ${
                  openIndex === index
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-4 md:px-5 pb-4 md:pb-5 text-sm text-foreground-400 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}